import { Util } from './../../app/util';
import { Component, Injector, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';

import { Dashboard } from '../dashboard/dashboard';
import { UserSignup } from '../user-signup/user-signup';
import { UserForgotpassword } from '../user-forgotpassword/user-forgotpassword';
import { Http } from '@angular/http';
import { Storage } from '@ionic/storage';
import { TermsPage } from '../terms/terms';
import { TranslateService } from '@ngx-translate/core';
import { EthemeProvider } from '../../providers/etheme/etheme';
import { Mj_Detail } from '../mj_detail/mj_detail';


@Component({
  selector: 'page-user-login',
  templateUrl: 'user-login.html',
})
export class UserLogin extends Util {
  user: string = "";
  pass: string = "";
  serr: any;
  showlogin: boolean = false;
  token: string = '';
  showtoken: boolean = false;
  // @ViewChild('campopassword') cpass;
  showp: boolean = false;
  
  tokenEYD = '';
  device = '';
  ssomicrosoft = false;
  // @ViewChild('videoPlayer') videoplayer: ElementRef;
  constructor(public navCtrl: NavController, public navParams: NavParams, injector: Injector, loading: LoadingController, public translate: TranslateService, public etheme: EthemeProvider) {
    super(injector, loading);
    //this.storage.remove('user');
    //this.storage.clear();



  }
  // ngAfterViewInit() {
  // }


  have_token() {
    this.showtoken = !this.showtoken;
  }
  ngAfterViewInit() {

    // setTimeout(() => {
    //   if(this.videoplayer)
    //     this.videoplayer.nativeElement.play();
    // }, 800);
    let url = document.URL;
    // if(url.indexOf('showSSO=1')!=-1){
    //   this.ssomicrosoft = true;
    // }
    if (url.indexOf('tokenEYD=') != -1) {
      if (url.indexOf("?") > 0) {
        let splitURL = document.URL.split("?");
        let splitParams = splitURL[1].split("&");
        let i: any;
        for (i in splitParams) {
          let singleURLParam = splitParams[i].split('=');
          if (singleURLParam[0] == "tokenEYD") {
            // this.category = singleURLParam[1];
            this.tokenEYD = singleURLParam[1];
            // console.log(this.tokenEYD);
            this.gs.tokenEYD = this.tokenEYD;
       


          }


        }
      }
    }
    if (url.indexOf('tokenFCM=') != -1) {
      if (url.indexOf("?") > 0) {
        let splitURL = document.URL.split("?");
        let splitParams = splitURL[1].split("&");
        let i: any;
        for (i in splitParams) {
          let singleURLParam = splitParams[i].split('=');
          if (singleURLParam[0] == "tokenFCM") {
            // this.category = singleURLParam[1];
            

            this.storage.set('tokenFCM', singleURLParam[1]);
       


          }
          if (singleURLParam[0] == "device") {
            this.device = singleURLParam[1];
          }

        }
      }
    }
    this.storage.get('user').then(user => {

      //console.log(user);
      if (user != null && user != undefined && user != '' && (this.gs.tokenEYD == '' || this.gs.tokenEYD == null)) {
        this.GetRequest('checksession', '', false, false).then((res) => {
          // this.loginWithUserEPass(user.username, user.password, false, false);
          this.gs.myuser = user;
          this.navCtrl.push(Dashboard);
        }).catch((err) => {
          //console.log(err);
          this.logout();
        })
      }
      else {
        if (this.gs.tokenEYD != '') {

          // this.navCtrl.push(Mj_Detail);

          this.PostRequest('verifytoken', '', { token: this.gs.tokenEYD }, false, true).then((r: any) => {
            // console.log(r);

            var datasave = { token: r['user']['token'], id: r['user']['id'] };
            // console.log(datasave);
            // datasave['user']['password'] = password;

            this.storage.set('user', datasave).then(() => {
              this.gs.myuser = datasave;
              this.GetRequest('me', '', true, false).then((userdata) => {
                let userxxx = userdata['user'];
                this.gs.userx = this.user;
                this.navCtrl.push(Mj_Detail, { mj: r.MicroJourney, 'user': userxxx }, { animate: false });
                // console.log(userdata);
              });
              //console.log('data --->',data);
              // this.navCtrl.push(Dashboard);

            })

          }).catch((err) => {
            console.log(err);
            // this.logout();
          })

        }
        else if (this.etheme.theme_selected == 'coachfit-theme') {
          setTimeout(() => {
            this.showlogin = true;
          }, 11000);
        }
        else if (this.etheme.theme_selected == 'sky-theme' || this.etheme.theme_selected == 'yamamay-theme' || this.etheme.theme_selected == 'carrefour-theme') {
          this.showlogin = true;
          this.login_sso();
        }
        else
          this.showlogin = true;

      }
    });

  }
  logout() {


    this.storage.remove('user');
    this.showlogin = true;

  }

  termini_condizioni() {
    // this.navCtrl.push(TermsPage);
    this.open_in_app_browser('http://www.skilleyd.net/site/gdpr/');
  }


  loginWithUserEPass(email: string, password: string, showAlert: boolean, savepass: boolean) {

    this.PostRequest('login', '', { username: email, password: password }, showAlert).then(data => {
      // //console.log(data);

      if (savepass) {
        // var datasave = data;
        // datasave['user']['password'] = this.pass;

        var datasave = { token: data['user']['token'], id: data['user']['id'] };
        //console.log(datasave);

        this.storage.set('user', datasave).then(() => {
          this.gs.myuser = datasave;
          if (this.showtoken)
            this.send_token();
          //console.log('data--->',data);
          this.navCtrl.push(Dashboard);
        })
      }
      else {
        // var datasave = data;
        var datasave = { token: data['user']['token'], id: data['user']['id'] };
        // datasave['user']['password'] = password;

        this.storage.set('user', datasave).then(() => {
          this.gs.myuser = datasave;
          //console.log('data --->',data);
          this.navCtrl.push(Dashboard);
        })
      }


    }).catch(err => {
      this.showlogin = true;
      if (showAlert) {

        var error_str = this.etic.en.errorlogin;
        if (err != null && err != undefined && err.errors != null) {
          error_str = err.errors;
        }
        //this.showBasicAlert('Errore', error_str);
        this.serr = JSON.stringify(err);
      }
      this.storage.remove('user');
      // this.storage.clear();
    });
  }

  login() {
    this.loginWithUserEPass(this.user, this.pass, true, true);
  }
  showpass() {
    this.showp = !this.showp;
  }
  send_token() {
    this.PostRequest('attivaToken', this.token, {}, true, true).then((res: any) => {
      this.showBasicAlert('Token', res.message);
      //console.log(res);
    }).catch((err) => {
      console.error(err);
    })
  }

  /*
    ionViewDidLoad() {
      
      //this.pass = "polizia";
  
      this.storage.get('user').then(user => {
        //console.log(user);
        
        if (user != null) {
          this.loginWithUserEPass(user.user.nomeutente, user.user.password, false);
        }
      });
  
    }
  
    loginWithUserEPass(email: string, password: string, showAlert: boolean) {
      this.PostRequest('login', '', { username: email, password: password }, showAlert).then(data => {
        
        this.storage.set('user', data);
        this.navCtrl.push(Dashboard,{user:data});
        
      }).catch(err => {
        
        if (showAlert) {
  
          var error_str = this.etic.en.errorlogin;
          if (err != null && err != undefined && err.errors != null) {
            error_str = err.errors;
          }
          //this.showBasicAlert('Errore', error_str);
          this.serr = JSON.stringify(err);
        }
        this.storage.clear();
      });
    }
  
    login() {
      this.loginWithUserEPass(this.user, this.pass, true);
    }
  */
  login_sso() {
    let url = document.URL;

    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('login')=='sso') {
      
      if(searchParams.has("error")&&searchParams.has("msg")){
        this.showBasicAlert('Errore', searchParams.get("msg"));
        this.storage.remove('user');
      }else if(searchParams.has('val')&& searchParams.has('id') ){
        var datasave = { token: searchParams.get('val'), id: searchParams.get('id') };
        this.storage.set('user', datasave).then(() => {
          this.gs.myuser = datasave;
          //console.log('data --->',data);
          //this.navCtrl.push(Dashboard);
          
          setTimeout(()=>{
            window.location.href="/"

          })
         
        });
      }else{
        var error_str = this.etic.en.errorlogin;
        this.showBasicAlert('Errore', error_str);
        this.storage.remove('user');
      }


     

    }

   /*else if (url.indexOf('login=sso') != -1) {
      this.GetRequestwithcredential('readSession', '').then((r: any) => {

        var datasave = { token: r.data['token'], id: r.data['user']['id'] };
        // datasave['user']['password'] = password;

        this.storage.set('user', datasave).then(() => {
          this.gs.myuser = datasave;
          //console.log('data --->',data);
          this.navCtrl.push(Dashboard);
        })
        // console.log(r);
        // this.dashboardPage();
      }).catch((err) => {


        var error_str = this.etic.en.errorlogin;
        if (err != null && err != undefined && err.errors != null) {
          error_str = err.errors;
        }
        this.serr = JSON.stringify(err);
        this.showBasicAlert('Errore', this.serr);

        this.storage.remove('user');
        // this.storage.clear();
      })*/
  }

  goto_portal_sky() {
    window.location.href = this.urlserver + 'sso/sky-sp';
  }
  goto_portal_yamapp() {

    
    window.open(this.urlserver + 'oauth2/yama-sp');
    // const wnd = 
    // const timer = setInterval(() => {
		// 	if (wnd.closed) {
		// 		clearInterval(timer);
		// 		console.log("xxxxxxxxxasd");
    //     window.location.href = "https://yamapp.eydlab.com/deep/qwerty1";
		// 		// this.showGoogleButton=false;
		// 		// this.save();
				
		// 	}
		// }, 1000)
    // window.location.href = this.urlserver + 'oauth2/yama-sp';
  }

  goto_portal_carrfour(){
    window.open(this.urlserver + 'oauth2/carrefour-sp');
    // window.open( 'https://api.eydlab.com/rest_debug/Api/v1.0.1/app/oauth2/carrefour-sp');
  }
  dashboardPage() { this.navCtrl.push(Dashboard, { user: this.user }); }
  signupPage() { this.navCtrl.push(UserSignup); }
  forgotPasswordPage() { this.navCtrl.push(UserForgotpassword); }

}



// WEBPACK FOOTER //
// ./src/pages/user-login/user-login.ts